import "./User.css";
import React from "react";
import ProfPage from './ProfPage/ProfPage';
import { USERS_ADMIN_NAVIGATION_ETUDIANTS } from "../../../Routes/NAVIGATION_PATH";
import { Tab, Tabs } from "react-bootstrap";
import StudentPage from "./StudentPage/StudentPage";

function template() {
  const user_navigation = {
    nom1: 'Professeurs',
    nom2: 'Etudiants',
    route1: '',
    route2: USERS_ADMIN_NAVIGATION_ETUDIANTS
  }
  return (
    <div className="user">
      <Tabs
        defaultActiveKey="Professeur"
        transition={false}
        id="justify-tab-example"
        className="mb-3 fw-bold fs-5"  
      >
        <Tab eventKey="Professeur" title="Professeur">
          <ProfPage />
        </Tab>
        <Tab eventKey="Etudiant" title="Etudiant">
          <StudentPage />
        </Tab>
      </Tabs>
    </div>
  );
};

export default template;
